import { z } from 'zod';
export const NATIVE_DESTINATIONS = ['store', 'orders', 'wallet', 'credit', 'documents', 'account', 'favorites', 'cart', 'discounts', 'support', 'catalog'];
export const NATIVE_DESTINATION_LABELS = {
    store: 'صفحه اصلی فروشگاه', orders: 'سفارش‌های مشتری', wallet: 'کیف پول', credit: 'اعتبار و اقساط',
    documents: 'تکمیل مدارک', account: 'حساب کاربری', favorites: 'علاقه‌مندی‌ها', cart: 'سبد خرید',
    discounts: 'کدهای تخفیف', support: 'پشتیبانی', catalog: 'کاتالوگ کالاها',
};
export const campaignDraftSchema = z.object({
    title: z.string().trim().min(1, 'عنوان پیام را وارد کنید.').max(80),
    body: z.string().trim().min(1, 'متن پیام را وارد کنید.').max(600),
    destination: z.enum(NATIVE_DESTINATIONS),
    audience: z.enum(['all', 'selected']),
    userIds: z.array(z.number().int().positive()).max(5000).default([]),
}).strict().refine(v => v.audience === 'all' || v.userIds.length > 0, 'حداقل یک مشتری انتخاب کنید.')
    .transform(v => ({ ...v, userIds: v.audience === 'all' ? [] : [...new Set(v.userIds)].sort((a, b) => a - b) }));
export const DELIVERY_STATUS_LABELS = {
    queued: 'در صف', processing: 'در حال ارسال', accepted: 'پذیرفته‌شده در سرویس پوش', failed: 'ناموفق',
    skipped: 'ارسال نشد', unknown: 'نتیجه نامشخص', cancelled: 'لغوشده',
};
export const CAMPAIGN_STATUS_LABELS = {
    draft: 'پیش‌نویس', queued: 'در صف ارسال', sending: 'در حال ارسال', completed: 'پایان ارسال', cancelled: 'لغوشده',
};
// Older APKs can still route these events to their closest supported screen.
export function campaignEvent(destination) {
    return `${destination === 'orders' ? 'order' : destination === 'documents' ? 'document' : destination}.announcement`;
}
//# sourceMappingURL=native-campaigns.js.map